<script lang="ts">
	import Info from '$lib/icons/info.svelte';
	import Modal from '$lib/modal/v2/modal.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import Affirm from '$lib/icons/affirm.svelte';
	import AffirmModalContent from '$lib/modals/bnplModal/affirmModalContent.svelte';

	interface Props {
		content: ISbStoryData<{
			label: string;
			align: 'one-line' | 'two-lines';
		}>['content'];
	}

	let { content }: Props = $props();
	let modal = $state<{ show: () => void; hide: () => void }>();
</script>

<button
	type="button"
	onclick={() => modal?.show()}
	class={[
		'z-1 relative  flex w-full text-[14px]/[160%] text-brown-4',
		content.align === 'two-lines'
			? ' -mb-1 flex-col items-start gap-y-1'
			: 'items-center justify-center gap-x-1'
	]}
>
	<Affirm class="mr-1 h-[18px]" />
	<div class="flex items-center gap-x-1">
		{content.label}
		<Info class="inline h-4 w-4" />
	</div>
</button>

<Modal withDesktopPadding size="regular" bind:this={modal} modalName="Affirm Modal">
	<AffirmModalContent />
</Modal>
